import { render, staticRenderFns } from "./RTypePlaceTable.vue?vue&type=template&id=767c14b1&scoped=true&"
import script from "./RTypePlaceTable.vue?vue&type=script&lang=js&"
export * from "./RTypePlaceTable.vue?vue&type=script&lang=js&"
import style0 from "./RTypePlaceTable.vue?vue&type=style&index=0&id=767c14b1&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767c14b1",
  null
  
)

/* custom blocks */
import block0 from "./RTypePlaceTable.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('767c14b1')) {
      api.createRecord('767c14b1', component.options)
    } else {
      api.reload('767c14b1', component.options)
    }
    module.hot.accept("./RTypePlaceTable.vue?vue&type=template&id=767c14b1&scoped=true&", function () {
      api.rerender('767c14b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/RTypePlaces/RTypePlaceTable.vue"
export default component.exports